import type { HealthCheckFinding, HealthCheckFindingDto } from '../models/healthCheck.types'

import { toAction } from './actionUrl'
import { categoryOf } from './grouping'
import { isRecent } from './recency'

import { META_CHECKPOINT_DIAGNOSTIC_LABEL } from '@/features/integrations'

function channelsOf(details: readonly Record<string, unknown>[]): string[] {
  const channels = new Set<string>()
  for (const detail of details) {
    const channel = detail.marketing_channel
    if (typeof channel === 'string' && channel.trim()) channels.add(channel)
  }
  return [...channels]
}

export function toFinding(dto: HealthCheckFindingDto, now = Date.now()): HealthCheckFinding {
  const details = dto.diagnostic_details ?? []
  const isDismissed = Boolean(dto.dismissed_at)
  return {
    id: dto.id,
    type: dto.type,
    category: categoryOf({ type: dto.type, isDismissed }),
    title: dto.title,
    content: dto.content,
    lastUpdate: dto.last_update,
    dismissedAt: dto.dismissed_at,
    isDismissed,
    isRecent: isRecent(dto.last_update, now),
    action: toAction(dto),
    details,
    hasDetails: details.length > 0,
    channels: channelsOf(details),
    isMetaCheckpoint: dto.diagnostic_label === META_CHECKPOINT_DIAGNOSTIC_LABEL,
  }
}

export function toFindings(
  dtos: readonly HealthCheckFindingDto[],
  now = Date.now(),
): HealthCheckFinding[] {
  return dtos.map((dto) => toFinding(dto, now))
}
